module.exports = __webpack_public_path__ + "static/media/close_up.245b6a1a.png";